export default __webpack_public_path__ + "static/media/leistungsangebot_bg.677a5495.jpg";